<template>
    <div class="todoList-module">

        <div class="select-box flex flex-y-center flex-start">
            <div class="select-item flex flex-between flex-y-center" @click="selectTimePopup">
                <div class="select-tit">{{ dateTxt }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
        </div>
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
            <div class="main-box">
                <div class="top-box flex flex-between flex-y-center">
                    <div class="top-item flex-y-center flex-col">
                        <div class="top-num">{{ todoEventData.unfinished }}</div>
                        <div class="top-tit">待完成</div>
                        <div class="top-sign blue"></div>
                    </div>
                    <div class="top-item flex-y-center flex-col">
                        <div class="top-num">{{ todoEventData.finished }}</div>
                        <div class="top-tit">已完成</div>
                        <div class="top-sign green"></div>
                    </div>
                    <div class="top-item flex-y-center flex-col">
                        <div class="top-num">{{ todoEventData.finishedRatio }}%</div>
                        <div class="top-tit">完成率</div>
                        <div class="top-sign yellow"></div>
                    </div>
                </div>
                <div class="list-box">
                    <div class="title">
                        待办事件
                    </div>
                    <div v-if="todoEventList.length != 0">
                        <div class="list-item" v-for="item, index in todoEventList" :key="index">
                            <div class="flex flex-y-center flex-col" @click="toEmployeeToDo(item.type, item.typeName, item.name)">
                                <div class="list-inner flex flex-y-center">
                                    <img class="list-icon" :src="item.iconPath" alt="" />
                                    <div class="flex-1 list-tit">{{ item.typeName }}&nbsp;&nbsp;<span
                                            style="color: #A0ACB5;">{{ item.finishedRatio }}%</span>
                                    </div>
                                    <div class="list-num">已完成{{ item.finished }} 待完成{{ item.unfinished }}</div>
                                </div>
                                <van-progress class="list-rate-box" :percentage="item.finishedRatio" :show-pivot="false"
                                    :color="`${item.finishedRatio < 50 ? '#ee0a24' : '#2FD0D5'}`" track-color="#fff" />
                            </div>
                        </div>
                    </div>
                    <div v-else class="flex flex-col flex-y-center">
                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png"
                            alt="" class="empty-icon" />
                        <div class="empty-txt">暂无</div>
                    </div>
                </div>
            </div>
        </van-pull-refresh>
        <van-popup v-model="showTimePopup" round position="bottom" closeable>
            <date-picker v-model="dateType" @submit="handleDate" :pickerType="pickerType"></date-picker>
        </van-popup>
    </div>
</template>

<script>
import request from "@/utils/request";
import DatePicker, { getFormatTime, getDateText, PICKER_TYPE } from '@/components/DatePicker';
import { Toast } from 'vant'
import { keepAliveAfterHandler } from "@/router/router";
import { mapState } from 'vuex'
import { getCookie } from '@/utils'

export default {
    name: 'toDoNewList',
    components: {
        DatePicker
    },
    data() {
        return {
            pickerType: PICKER_TYPE.MONTH,// 日期控件类型
            refreshing: false,//刷新
            page: 1,
            total: 0,
            todoEventData: {},//待办数据
            todoEventList: [],//待办列表
            showTimePopup: false,//选择时间弹窗
            dateType: '2',//日期对应id 1-本日；2-本月；3-上月
            beginMonth: '',//开始日期
            endMonth: '',//结束日期
            postId: 0, // 岗位

        }
    },
    computed: {
        dateTxt() {
            return getDateText(this.dateType, this.beginMonth, this.endMonth, this.pickerType)
        },
        ...mapState({
            regionPostId: (state) => {
                return state.user.permissions.regionPostId
            },// 区经区总id
        }),
    },
    beforeRouteLeave(to, from, next) {
        keepAliveAfterHandler.call(this, to, from)
        next()
    },
    mounted() {
        this.postId = getCookie('postId') || localStorage.getItem('postId');
        console.log(this.postId);
        this.getToDoList()
    },
    methods: {
        init() {
            // 初始化data的值
            Object.assign(this.$data, this.$options.data())
            this.getToDoList()

        },
        // 获取列表
        getToDoList() {
            const beginDate = getFormatTime(this.beginMonth, this.pickerType)
            const endDate = getFormatTime(this.endMonth, this.pickerType)
            let params = {
                beginMonth: beginDate,
                endMonth: endDate,
                dateType: this.dateType,
            }
            if (this.regionPostId.includes(this.postId)) {
                params.id = this.$route.query.id,
                    params.storeId = this.$route.query.storeId
            }
            request({
                url: "/todo/finishedStatistic",
                method: "get",
                params: params
            })
                .then((res) => {
                    this.todoEventData = res.data
                    this.todoEventList = res.data.typeStatisticList
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        // 刷新
        onRefresh() {
            this.refreshing = false;
        },
        // 弹窗
        selectTimePopup() {
            this.showTimePopup = true
        },
        // 日期确定
        handleDate(id, begin, end) {
            this.showTimePopup = false
            this.dateType = id
            if (!id) {
                this.beginMonth = begin
                this.endMonth = end
            } else {
                this.beginMonth = ''
                this.endMonth = ''
            }
            this.getToDoList()
        },
        //  跳转员工待办
        toEmployeeToDo(type, typeName) {
            // if (type == 12) {
            //     this.$router.push({ name: 'repairOrderHome', query: {} });
            // } else {
            this.$router.push({
                name: 'employeeToDo', query: {
                    type, typeName,
                    id: this.$route.query.id,
                    storeId: this.$route.query.storeId
                }
            });
            // }
        },
        onRefresh() {
            // // 将 loading 设置为 true，表示处于加载状态
            this.bookingData = [];
            this.refreshing = false;
            this.getToDoList();
        },
    },
}
</script>

<style scoped lang="less">
.ml-20 {
    margin-left: 20px;
}

::-webkit-scrollbar {
    display: none;
}

.todoList-module {
    height: 100%;
    background-color: #ffffff;
    overflow-y: auto;
}

.select-box {
    padding: 30px;
    padding-bottom: 20px;

    .select-item {
        margin-right: 15px;
    }

    .select-tit {
        font-size: 28px;
        color: #35434c;
    }

    .select-arrow {
        transform: rotate(90deg);
        font-size: 24px;
        margin-left: 10px;
    }
}

.main-box {
    min-height: calc(100vh - 102px);
    // padding-bottom: 130px;
    padding: 30px 30px;
}

.top-box {
    margin-bottom: 50px;

    .top-item {
        width: 200px;
        height: 128px;
        background: #ffffff;
        box-shadow: 4px 5px 20px 0px rgba(0, 0, 0, 0.08);
        border-radius: 10px;
        position: relative;
        justify-content: center;
        overflow: hidden;
    }

    .top-num {
        font-size: 36px;
        font-weight: 700;
        color: #35434c;
    }

    .top-tit {
        font-size: 26px;
        font-weight: 400;
        color: #a0acb5;
    }

    .top-sign {
        position: absolute;
        right: -25px;
        bottom: -25px;
        width: 70px;
        height: 70px;
        border-radius: 50%;
    }

    .top-sign.blue {
        background: #4a6be6;
    }

    .top-sign.green {
        background: #4bca85;
    }

    .top-sign.yellow {
        background: #f3d168;
    }
}

.list-box {
    padding-bottom: 50px;

    .title {
        font-size: 34px;
        font-weight: 700;
        color: #35434c;
        margin-bottom: 40px;
    }

    .list-item {
        width: 690px;
        height: 138px;
        background: #fafafe;
        border-radius: 10px;
        padding: 30px 20px;
        margin-bottom: 20px;

        .list-inner {
            width: 100%;
            margin-bottom: 20px;
        }

        .list-icon {
            width: 50px;
            max-height: 50px;
            margin-right: 25px;
        }

        .list-tit {
            font-size: 30px;
            font-weight: 400;
            color: #35434c;
        }

        .list-num {
            font-size: 26px;
            font-weight: 400;
            color: #35434c;
        }

        .list-rate-box {
            width: 580px;
            margin-left: 90px;
        }
    }
}

.empty-icon {
    width: 280px;
    height: 280px;
    margin-top: 179px;
}

.empty-txt {
    font-size: 30px;
    color: #a0acb5;
}

:deep(.van-popup__close-icon--top-right) {
    top: 50px;
}
</style>
